import type { IMaskFunction } from 'interfaces/IMask';

const bankaccountdigit: IMaskFunction = {
  apply: (value: string) => {
    if (!value) return value;

    return value.replace(/[^0-9xX]/g, '');
  },
  clean: (value: string) => value.substr(0, 1)
};

export default bankaccountdigit;
